export function resolveUserStatus(user, userData = {}) {
  const firestoreStatus = typeof userData?.status === 'string' ? userData.status : null;

  if (user?.emailVerified && (!firestoreStatus || firestoreStatus === 'pending_verification')) {
    return 'active';
  }

  return firestoreStatus || 'pending_verification';
}

export function shouldSyncVerifiedUserStatus(user, userData = {}) {
  const firestoreStatus = typeof userData?.status === 'string' ? userData.status : null;
  return !!user?.emailVerified && (!firestoreStatus || firestoreStatus === 'pending_verification');
}

// Projects the account-relevant fields off a users/{uid} document into the
// shape stored on AuthContext.userAccount. Used for both the initial getDoc
// hydration and the live onSnapshot listener so a mid-session credit spend or
// entitlement grant is reflected everywhere (GH #696 round-2).
export function mapUserAccountFields(userData = {}) {
  return {
    subscriptionStatus: userData.subscriptionStatus || userData.subscription_status || null,
    subscription_status: userData.subscription_status || null,
    isDynamic: userData.isDynamic === true,
    reportPurchaseDate: userData.reportPurchaseDate || null,
    starterWindowExpiry: userData.starterWindowExpiry || null,
    currentPeriodEnd: userData.currentPeriodEnd || null,
    current_period_end: userData.current_period_end || null,
    creditBalance: userData.creditBalance,
    priceId: userData.priceId || null,
    currentPriceId: userData.currentPriceId || null,
    subscriptionPriceId: userData.subscriptionPriceId || null,
    subscription: userData.subscription || null,
  };
}
